export default __webpack_public_path__ + "static/media/sign_in_3.16e4218e.png";